module.exports = __webpack_public_path__ + "img/microphone-stand.d2cc1ea5.svg";